module.exports = __webpack_public_path__ + "img/pos7-icon.5f44676e.png";